export const texts = [
  {
    title: "Котёнок (Л. Толстой)",
    description: `<p>Были брат и сестра - Вася и Катя; и у них была кошка. Весной кошка пропала. Дети искали её везде, но не могли её найти. Один раз они играли подле амбара и услыхали- над головой что-то мяучит тонкими голосами. Вася влез по лестнице под крышу амбара. А Катя стояла внизу и всё спрашивала:</p>
    <p>- Нашёл? Нашёл?</p>
    <p>Но Вася не отвечал ей. Наконец Вася закричал:</p>
    <p>- Нашёл! Наша кошка... И у неё котята; такие чудесные; иди сюда скорее.</p>
    <p>Катя побежала домой, достала молока и принесла кошке.</p>
    <p>Котят было пять. Когда они выросли немножко и стали вылезать из-под угла, где вывелись, дети выбрали себе одного котёнка, серого с белыми лапками, и принесли в дом. Мать раздала всех остальных котят, а этого оставила детям. Дети кормили его, играли с ним и клали с собой спать.</p>`,
    questions: [
      {
        question: "Кто автор текста?",
        answers: ["Носов", "Чуковский", "Толстой"]
      },
      {
        question: "Как звали детей?",
        answers: ["Вася и Катя", "Миша и Оля", "Вася и Юля"]
      },
      {
        question: "Где дети нашли кошку?",
        answers: ["На козырьке крыльца", "На крыше амбара", "У магазина"]
      },
      {
        question: "Сколько было котят?",
        answers: ["3", "5", "6"]
      }
    ],
    rightAnswers: [2, 0, 1, 1]
  },
  {
    title: "Осенью (С. Аксаков)",
    description: `<p>Осень, глубокая осень! Серое небо, низкие, тяжёлые, влажные облака. Голы и прозрачны становятся сады, рощи и леса. Всё видно насквозь в самой глухой древесной чаще, куда летом не проникал глаз человеческий.</p>
    <p>Старые деревья давно облетели, и только молодые отдельные берёзки сохраняют свои увядшие желтоватые листья, блистающие золотом, когда тронут их косые лучи невысокого осеннего солнца.</p>
    <p>Ярко выступают сквозь красноватую сеть берёзовых ветвей вечнозелёные, как будто помолодевшие ели и сосны, освежённые холодным воздухом, мелкими, как пар, дождями и влажными ночными туманами.</p>
    <p>Устлана земля сухими, разновидными и разноцветными листьями: мягкими и пухлыми в сырую погоду, так что не слышно шелеста от ног осторожно ступающего охотника, и жёсткими, хрупкими в морозы, так что далеко вскакивают звери и птицы от шороха человеческих шагов.</p>`,
    questions: [
      {
        question: "Кто автор текста?",
        answers: ["Аксаков", "Пушкин", "Тургенев"]
      },
      {
        question: "Какие деревья давно облетели?",
        answers: ["старые", "крупные", "сухие"]
      },
      {
        question: "Какие молодые деревья сохраняют увядшие листья?",
        answers: ["Ивы", "Березки", "Осинки"]
      },
      {
        question: "Не слышно шелеста ног… Кого?",
        answers: ["Грибника", "Егеря", "Охотника"]
      }
    ],
    rightAnswers: [0, 0, 1, 2]
  },
  {
    title: "Грусть",
    description: `<p>В этот день, который был вторник, ничего особенного с Лугиным не случилось: он до вечера просидел дома, хотя ему нужно было куда-то ехать. Непостижимая лень овладела всеми чувствами его; хотел рисовать — кисти выпадали из рук; пробовал читать — взоры его скользили над строками и читали совсем не то, что было написано; его бросало в жар и в холод; голова болела; звенело в ушах. Когда смерклось, он не велел подавать свеч и сел у окна, которое выходило на двор; на дворе было темно; у бедных соседей тускло светились окна; он долго сидел; вдруг на дворе заиграла шарманка; она играла какой-то старинный немецкий вальс; Лугин слушал, слушал — ему стало ужасно грустно. Он начал ходить по комнате; небывалое беспокойство им овладело; ему хотелось плакать, хотелось смеяться...</p>`,
    questions: [
      {
        question: "Как называется рассказ?",
        answers: ["Печаль", "Грусть", "Отчаяние"]
      },
      {
        question: "В какой день происходят события?",
        answers: ["Понедельник", "Вторник", "Четверг"]
      },
      {
        question: "Какая фамилия главного героя?",
        answers: ["Лукин", "Парков", "Лугин"]
      },
      {
        question: "Какой музыкальный инструмент заиграл на улице?",
        answers: ["Скрипка", "Шарманка", "Флейта"]
      }
    ],
    rightAnswers: [1, 1, 2, 1]
  },
  {
    title: "Воспоминания",
    description: ` <p>Воспоминания, одно другого заманчивей, зароились в голове... То вспомнится далёкое детство... Яркая зелень муравы на лужайке...</p>
    <p>Звонкие голоса детей, играющих на той лужайке... Залитый белыми пахучими цветами вишенник в саду... Весёлый птичий гам в далёкой роще — там, за садом... Тихая река, поросшая ветлами и зелёным камышом; за рекой — поёмные луга с бесчисленными, блестящими как зеркало, озёрами, необъятная даль, подёрнутая сизым туманом, и над всем этим привольем — чудно сверкающее майское солнышко...</p>
    <p>Встаёт хуторок, затерянный в глуши. Безграничная степь кругом того хуторка. Далёкие курганы, тёмными очертаниями пестрящие горизонт, и над всем этим простором — горячее синее небо и глубокая, невозмутимая тишь...</p>
    <p>Как бы хорошо улететь и остаться там — в этой чудной стране былых впечатлений, былых радостей!..</p>`,
    questions: [
      {
        question: "Как называется рассказ?",
        answers: ["Детство", "Впечатления", "Воспоминания"]
      },
      {
        question: "Какое солнышко сверкало?",
        answers: ["Майское", "Летнее", "Июньское"]
      },
      {
        question: "О каком населенном пункте говорит автор?",
        answers: ["Деревенька", "Хуторок", "Посёлок"]
      },
      {
        question: "Что пожелал автор в конце?",
        answers: [
          "Улететь и остаться там",
          "Вспоминать почаще о прошлом",
          "Поделиться впечатлениями о чудной стране"
        ]
      }
    ],
    rightAnswers: [2, 0, 1, 0]
  }
];
